// Exposures
// TODO - Documentar
import * as con from "../../GlobalConstants"

import { EDIT_COMMAND, VIEW_ANNOTATIONS_COMMAND } from '../transactionTable/TransactionTableConstants'

// Style
import "../ComponentsGlobalStyle.css"
import { TransactionTable } from '../transactionTable/TransactionTable'
import TransactionTableVisualizer from './TransactionTableVisualizer'
import { AccountsHook, useTransactionAnnotations } from '../hooks/TransactionsHooks'
import { filterObject } from '../../GlobalFunctions'
import { RefModelParameterHook } from '../hooks/ModelParameterHooks'
import { allAccountColumns, selectedAccountColumns } from '../../utils/transactionFunctions'
import { useDispatch } from "react-redux"
import { updateTransaction } from "../../store/slices/transactionsSlice"

function TableAccounts() {

  // Transaction
  const trans = AccountsHook()

  // Client Type
  const clientType = RefModelParameterHook(con.CLIENT_TYPE)
  const dispatch = useDispatch()
  const getAnnotations = useTransactionAnnotations(con.ACCOUNTS)

  // Columns
  const columns = selectedAccountColumns.map(col => allAccountColumns[col[con.ID]]) 

  return (         
            <TransactionTableVisualizer transactionType={con.ACCOUNTS}>             
                    <TransactionTable   transactionType={con.ACCOUNTS}
                                        columnArray={columns} 
                                        dataDictionary={clientType === con.IMPORTER ? trans : filterObject(trans, acc => acc[con.ACCOUNT_TYPE] === con.NATURAL_COVERAGE) } 
                                        setRow={(id, vals) =>
                                          dispatch(updateTransaction({
                                            transactionType: con.ACCOUNTS,
                                            id,
                                            values: vals
                                          }))
                                        }
                                        getAnnotations={getAnnotations}
                                        commands={[EDIT_COMMAND, VIEW_ANNOTATIONS_COMMAND]}
                                        includeAddition={false}
                          />
            </TransactionTableVisualizer>
 
  )
}

export default TableAccounts